export default "__VITE_ASSET__C10hjdEw__"